import { IRUMRecorder } from "./IRUMRecorder";
import { RUMAPICall } from "./RUMAPICall";
import { ServiceType } from "../ServiceManager";
import { ClientWebsiteConfig, Config } from "../Config";
import { Client } from "../API/Client";
import { APIRequest, APIRequestMethod } from "../API/APIRequest";
import { AsyncQueueDelegate, AsyncQueue } from "../../util/AsyncQueue";
import { RUMJSEvent } from "./RUMJSEvent";

enum SkywalkerRUMEventType {
  APICall,
  JSEvent,
  PageLoad,
  WebsiteOutage,
  DeviceMeta
}

interface RUMDeviceMeta {
  UserAgent: string;
  Language: string;
  Platform: string;
  Memory: number;
  Concurrency: number;
  ScreenWidth: number;
  ScreenHeight: number;
  ViewportWidth: number;
  ViewportHeight: number;
  ColourDepth: number;
  Downlink: number;
  RTT: number;
}

interface SkywalkerRUMEvent {
  data: RUMAPICall | RUMJSEvent | PerformanceNavigationTiming | RUMDeviceMeta;
  type: SkywalkerRUMEventType;
}

class SkywalkerRUM implements IRUMRecorder, AsyncQueueDelegate<SkywalkerRUMEvent> {
  Type: ServiceType = ServiceType.RUMRecorder;
  Id: string = 'SkywalkerRUM';
  
  Queue: AsyncQueue<SkywalkerRUMEvent> = new AsyncQueue<SkywalkerRUMEvent>(2000, this);
  Config: ClientWebsiteConfig;

  constructor(config: ClientWebsiteConfig) {
    this.Config = config;
  }

  Flush(queue: SkywalkerRUMEvent[]): Promise<boolean> {
    return new Promise((resolve, reject) => {
      Client.Request(new APIRequest(APIRequestMethod.POST, '/api/rum/clientweb/events', {
        events: queue,
        websiteId: this.Config.Id
      }).SetHost(Config.RUM.Skywalker.Base).SetRUMEnabled(false)).then(() => {
        resolve(true);
      }).catch((err) => {
        reject(err);
      });
    });
  }

  ReportOutage(websiteId: string, error: Error): void {
    this.Queue.Push({
      data: RUMJSEvent.FromDOMError(error),
      type: SkywalkerRUMEventType.WebsiteOutage
    });
  }

  RecordAPI(apicall: RUMAPICall): void {
    this.Queue.Push({
      data: apicall,
      type: SkywalkerRUMEventType.APICall
    });
  }

  RecordPageLoad(timing: PerformanceNavigationTiming): void {
    this.Queue.Push({
      data: timing,
      type: SkywalkerRUMEventType.PageLoad
    });
  }

  RecordJSEvent(event: RUMJSEvent): void {
    this.Queue.Push({
      data: event,
      type: SkywalkerRUMEventType.JSEvent
    });
  }

  ReportAPIError(apicall: RUMAPICall): void {
    this.Queue.Push({
      data: apicall,
      type: SkywalkerRUMEventType.APICall
    });
  }

  ReportDeviceMeta(): void {
    const nav = navigator as any;

    this.Queue.Push({
      type: SkywalkerRUMEventType.DeviceMeta,
      data: {
        UserAgent: navigator.userAgent,
        Language: navigator.language,
        Platform: navigator.platform,
        Memory: nav.deviceMemory,
        Concurrency: navigator.hardwareConcurrency,
        ScreenWidth: window.screen.width,
        ScreenHeight: window.screen.height,
        ViewportWidth: window.screen.availWidth,
        ViewportHeight: window.screen.availHeight,
        ColourDepth: window.screen.colorDepth,
        Downlink: nav.connection?.downlink,
        RTT: nav.connection?.rtt
      } as RUMDeviceMeta
    });
  }
}

export { SkywalkerRUM }
